export default __webpack_public_path__ + "static/media/gallery_11.38bf1366.jpg";